var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIntermediatePointHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 39C20 38.4477 20.4477 38 21 38H40C40.5523 38 41 38.4477 41 39C41 39.5523 40.5523 40 40 40H21C20.4477 40 20 39.5523 20 39Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19 39C19 37.8954 19.8954 37 21 37C22.1046 37 23 37.8954 23 39C23 40.1046 22.1046 41 21 41C19.8954 41 19 40.1046 19 39Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H22V39C22 39.5523 21.5523 40 21 40V40C20.4477 40 20 39.5523 20 39V15Z",
    fill: "#414146"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H40H40.4824C41.3205 12 42 12.6795 42 13.5176C42 13.8315 41.9027 14.1376 41.7215 14.3939L37.05 21L41.7215 27.6061C41.9027 27.8624 42 28.1685 42 28.4824C42 29.3205 41.3205 30 40.4824 30H40H20V12Z",
    fill: "#414146"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H39.5508L34.6006 21L39.5508 14H22V28Z",
    fill: "#FF8F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 12H40H40.4824C41.3205 12 42 12.6795 42 13.5176C42 13.8315 41.9027 14.1376 41.7215 14.3939L37.05 21L41.7215 27.6061C41.9027 27.8624 42 28.1685 42 28.4824C42 29.3205 41.3205 30 40.4824 30H40H20V12Z",
    fill: "url(#paint0_linear_2267_164588)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2267_164588",
    x1: 31,
    y1: 12,
    x2: 31,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIntermediatePointHover);
export default __webpack_public_path__ + "static/media/map_intermediate_point_hover.596d93e7cb48f268475cae60161cac69.svg";
export { ForwardRef as ReactComponent };